<template>
  <div
    class="va-action"
    :class="row ? 'va-action-row' : 'va-action-tile'"
    role="button"
    tabindex="0"
    :aria-label="ariaLabel || text"
    @click="$emit('select')"
    @keydown.enter.prevent="$emit('select')"
    @keydown.space.prevent="$emit('select')"
  >
    <span class="va-circle-icon va-action-icon" :class="{ 'va-action-icon-large': row }">
      <v-icon v-if="mdi" :size="row ? 15 : 16" color="primary">{{ mdi }}</v-icon>
      <v-icon v-else class="va-icon" :size="row ? 16 : 18" color="primary">{{
        _icon(icon)
      }}</v-icon>
    </span>
    <span class="va-action-text">
      <span v-if="label" class="va-action-label">{{ label }}</span>
      <span class="va-action-main">{{ text }}</span>
    </span>
    <v-icon v-if="row" size="14" color="#8a97ab">{{ mdiChevronRight }}</v-icon>
  </div>
</template>

<style>
.va-action {
  cursor: pointer;
  min-width: 0;
}

/* Mobile: bloco suave lado a lado com o vizinho. */
.va-action-tile {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-radius: 12px;
  background: #f5f6fa;
  transition: background-color 0.15s ease;
}

.va-action-tile:hover {
  background: #eef0f5;
}

/* Desktop: linha dentro do trilho lateral. */
.va-action-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #e6e9ef;
}

.va-action-row:last-child {
  border-bottom: none;
}

/* Duas classes de proposito: `.va-circle-icon` pinta o fundo cinza e, no
   CSS extraido do build, chega depois deste arquivo. Sem isso a bolinha
   branca some contra o bloco cinza. */
.va-action .va-action-icon {
  width: 28px;
  height: 28px;
  background: #ffffff;
}

.va-action .va-action-icon-large {
  width: 32px;
  height: 32px;
}

.va-action-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.va-action-label {
  font-size: 12px;
  line-height: 16px;
  color: #6b7a90;
}

.va-action-main {
  font-size: 13px;
  line-height: 17px;
  color: #193153;
  text-wrap: pretty;
}

.va-action-row .va-action-main {
  font-size: 14px;
  line-height: 19px;
}
</style>

<script>
import { mdiChevronRight } from "@mdi/js";

export default {
  name: "HomeActionRow",
  props: {
    /** Caminho SVG do @mdi/js. Alternativa a `icon`. */
    mdi: {
      type: String,
      default: null,
    },
    /** Chave de ícone do set do app registrado no Vuetify. */
    icon: {
      type: String,
      default: null,
    },
    /** Linha pequena acima do texto (ex.: "Continue de onde parou"). */
    label: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    /** Variante de linha (desktop, no trilho) em vez de bloco (mobile). */
    row: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiChevronRight,
    };
  },
};
</script>
